import LoginContent from '../loginComponents/loginContent';
import LoginHeader from '../loginComponents/loginHeader';

export default function LoginPage() {

  return (
      <>
        <LoginHeader/>
        <LoginContent/>
      </>
  )
}